import { atom } from "jotai";
import componentStackAtom from "./componentStackAtom";
import componentStackIdsAtom from "./ComponentStackIdsAtom";
import { requestCurrentStackEntryClose } from "./requestCurrenStackEntryClose";

const removeComponentFromStack = atom(null, async (get, set) => {
  const canRemoveCurrent = await requestCurrentStackEntryClose(get);

  if (!canRemoveCurrent) {
    return false;
  }

  const nextStack = get(componentStackAtom).slice(0, -1);

  set(componentStackAtom, nextStack);
  set(
    componentStackIdsAtom,
    nextStack.map((entry) => get(entry.componentAtom).componentId),
  );

  return true;
});

export default removeComponentFromStack;
